import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { float64_type, string_type, union_type, class_type, record_type, bool_type, obj_type, lambda_type, unit_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dashboard_MeineLetzteSendung, Dashboard_ToggleNotificationRequest_$reflection, Dashboard_ToggleNotificationRequest, Dashboard_MeineLetzteSendung_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { map, toArray, ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { createObj, int32ToString, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Page } from "../LetzteSendung/Types.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../../../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { defaultArg, value as value_24 } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import * as react from "react";
import { bfsTile, navigationArrow } from "../Shared/Tile.fs.js";
import { notificationBox } from "./Shared.fs.js";
import { op_Subtraction, toNumber, fromParts } from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";
import { reactApi } from "../../../fable_modules/Feliz.Recharts.4.3.0/../Feliz.2.9.0/Interop.fs.js";
import { PieChart, Pie, Cell } from "recharts";
import { reactApi as reactApi_1 } from "../../../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { asMoney } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";

export class Model extends Record {
    constructor(GlobalDispatch, NavigateTo, Loading, Data, SavingToggle) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.NavigateTo = NavigateTo;
        this.Loading = Loading;
        this.Data = Data;
        this.SavingToggle = SavingToggle;
    }
}

export function Model_$reflection() {
    return record_type("Dashboard.MeineLetzteSendung.Model", [], Model, () => [["GlobalDispatch", lambda_type(GlobalMsg_$reflection(), unit_type)], ["NavigateTo", lambda_type(obj_type, unit_type)], ["Loading", bool_type], ["Data", Dashboard_MeineLetzteSendung_$reflection()], ["SavingToggle", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "ToggleBenachrichtigung", "NotificationToggled", "NavigateToList"];
    }
}

export function Msg_$reflection() {
    return union_type("Dashboard.MeineLetzteSendung.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_MeineLetzteSendung_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Dashboard_MeineLetzteSendung_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], []]);
}

export function Http_loadSendungseingang() {
    const response = fetch("/api/dashboard/meine-letzte-sendung", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_MeineLetzteSendung_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_setNotificationForBelegpruefungAbgeschlossen(enabled) {
    const payload = new Dashboard_ToggleNotificationRequest(enabled);
    return sendJson("/api/dashboard/set-notification-for-belegpruefung-abgeschlossen", toString(0, Auto_generateBoxedEncoder_437914C6(Dashboard_ToggleNotificationRequest_$reflection(), undefined, undefined, undefined)(payload)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function State_init(props) {
    return [new Model(props.GlobalDispatch, props.NavigateTo, true, new Dashboard_MeineLetzteSendung(undefined, false), true), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Die Daten für Ihre letzte Sendung können zur Zeit leider nicht geladen werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, model.Data, model.SavingToggle), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, false, msg.fields[0].fields[0], false), Cmd_none()];
            }
        case 2: {
            const newValue = !model.Data.Benachrichtigung;
            return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, new Dashboard_MeineLetzteSendung(model.Data.LetzteSendung, newValue), false), request(Http_setNotificationForBelegpruefungAbgeschlossen, newValue, (Item_2) => (new Msg(3, [Item_2])))];
        }
        case 3:
            if (msg.fields[0].tag === 1) {
                model.GlobalDispatch(new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5("Ihre neuen Benachrichtigungseinstellungen können zur Zeit leider nicht gespeichert werden.")]));
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, new Dashboard_MeineLetzteSendung(model.Data.LetzteSendung, !model.Data.Benachrichtigung), false), Cmd_none()];
            }
            else {
                return [new Model(model.GlobalDispatch, model.NavigateTo, model.Loading, model.Data, false), Cmd_none()];
            }
        case 4: {
            model.NavigateTo(new Page());
            return [model, Cmd_none()];
        }
        default:
            return [new Model(model.GlobalDispatch, model.NavigateTo, true, model.Data, true), request(Http_loadSendungseingang, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

export class PieSlice extends Record {
    constructor(color, value, key) {
        super();
        this.color = color;
        this.value = value;
        this.key = key;
    }
}

export function PieSlice_$reflection() {
    return record_type("Dashboard.MeineLetzteSendung.PieSlice", [], PieSlice, () => [["color", string_type], ["value", float64_type], ["key", string_type]]);
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_24("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\WebParts\\User\\Dashboard\\MeineLetzteSendung.fs") + "#L") + int32ToString(value_24(119))) + ";") + "Dashboard.Shared.DashboardProps", value_24("View"), (props) => {
    let matchValue_2, sendung, angekauft, matchValue_4, chartData, children_2, properties_2, elements_1, properties_1, elements, matchValue_6, sendung_1, children_10, children_8, children_30, children_28, children_26, children_18, children_16, children_24, children_22;
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const titleAction = react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(4, []));
        },
    }, navigationArrow);
    const footer = model_1.Loading ? undefined : notificationBox("Benachrichtigung", model_1.Data.Benachrichtigung, model_1.SavingToggle, (_arg_3) => {
        dispatch(new Msg(2, []));
    }, "Letzte-Sendung-Toggle");
    return bfsTile("Meine letzte Sendung", titleAction, (matchValue_2 = model_1.Data.LetzteSendung, model_1.Loading ? undefined : ((matchValue_2 != null) ? ((sendung = matchValue_2, (angekauft = ((matchValue_4 = sendung.Angekauft, (matchValue_4 == null) ? fromParts(0, 0, 0, false, 0) : matchValue_4)), (chartData = ofArray([new PieSlice("gray", toNumber(angekauft), "angekauft"), new PieSlice("lightgray", toNumber(op_Subtraction(sendung.Gesamtvolumen, angekauft)), "volumen")]), (children_2 = [(properties_2 = ofArray([["margin", {
        top: defaultArg(0, 0),
        right: defaultArg(0, 0),
        left: defaultArg(0, 0),
        bottom: defaultArg(0, 0),
    }], ["height", 80], ["width", 80], (elements_1 = singleton((properties_1 = ofArray([["data", toArray(chartData)], ["dataKey", (data) => data.value], ["cx", ~~(80 / 2)], ["cy", ~~(80 / 2)], ["innerRadius", ~~(80 / 3)], ["outerRadius", ~~(80 / 2)], (elements = map((data_1) => reactApi.createElement(Cell, {
        fill: data_1.color,
        key: data_1.key,
    }), chartData), ["children", ["children", reactApi_1.Children.toArray(Array.from(elements))]])]), reactApi.createElement(Pie, createObj(properties_1)))), ["children", reactApi_1.Children.toArray(Array.from(elements_1))])]), reactApi.createElement(PieChart, createObj(properties_2)))], react.createElement("div", {
        className: "chart",
    }, ...children_2)))))) : react.createElement("img", {
        className: "dashboard-icon",
        src: "dashboard/sendung_waiting_96x96.svg",
    }))), model_1.Loading ? spinner : ((matchValue_6 = model_1.Data.LetzteSendung, (matchValue_6 != null) ? ((sendung_1 = matchValue_6, [react.createElement("div", {
        className: "is-size-7 has-text-grey-light",
    }, `Sendung ${sendung_1.SendungsNummer}:`), (children_10 = [(children_8 = [asMoney(sendung_1.Gesamtvolumen)], react.createElement("b", {
        className: "is-size-4 nowrap",
    }, ...children_8))], react.createElement("div", {}, ...children_10)), react.createElement("div", {
        className: "is-size-7 has-text-grey-light",
    }, "Sendungswert"), (children_30 = [(children_28 = [(children_26 = [(children_18 = [react.createElement("td", {
        className: "pr-2",
    }, "Angekauft:"), (children_16 = [asMoney(defaultArg(sendung_1.Angekauft, fromParts(0, 0, 0, false, 0)))], react.createElement("td", {}, ...children_16))], react.createElement("tr", {
        className: "has-text-weight-bold",
    }, ...children_18)), (children_24 = [react.createElement("td", {
        className: "pr-2",
    }, "Nicht angekauft:"), (children_22 = [asMoney(defaultArg(sendung_1.NichtAngekauft, fromParts(0, 0, 0, false, 0)))], react.createElement("td", {}, ...children_22))], react.createElement("tr", {
        className: "subtle",
    }, ...children_24))], react.createElement("tbody", {}, ...children_26))], react.createElement("table", {
        className: "mt-4",
    }, ...children_28))], react.createElement("div", {}, ...children_30))])) : react.createElement("div", {}, "Wir freuen uns auf Ihre erste Sendung!"))), footer);
}, undefined, undefined, "Of");

//# sourceMappingURL=MeineLetzteSendung.fs.js.map
